import { jsonApi } from "@spree/storefront-api-v2-sdk";
import { requireConfigValue } from "../../isomorphic-config";
const normalizeTaxon = (spreeSuccessResponse, spreeTaxon)=>{
    const spreeTaxonChildren = jsonApi.findRelationshipDocuments(spreeSuccessResponse, spreeTaxon, "children");
    const children = spreeTaxonChildren.map((child)=>{
        return {
            id: child.id,
            name: child.attributes.name,
            permalink: child.attributes.permalink
        };
    });
    let taxonImage = null;
    try {
        const spreeTaxonImage = jsonApi.findSingleRelationshipDocument(spreeSuccessResponse, spreeTaxon, "image");
        if (spreeTaxonImage) {
            const host = requireConfigValue("imageHost");
            const url = process.env.nextEnv === "development" ? `${host}${spreeTaxonImage.attributes.original_url}` : spreeTaxonImage.attributes.original_url;
            taxonImage = {
                url: url,
                alt: spreeTaxonImage.attributes.alt
            };
        } else {
            taxonImage = null;
        }
    } catch (error) {
        taxonImage = null;
    }
    let spreeTaxonomy;
    try {
        spreeTaxonomy = jsonApi.findSingleRelationshipDocument(spreeSuccessResponse, spreeTaxon, "taxonomy");
    } catch (error1) {
        spreeTaxonomy = null;
    }
    const isLeaf = spreeTaxon.attributes.is_leaf// The 'any' is intentional here because there is a type BUG in the Storefront Spree SDK.
    ;
    let leafTaxons = null;
    if (isLeaf) {
        try {
            const spreeTaxonParent = jsonApi.findSingleRelationshipDocument(spreeSuccessResponse, spreeTaxon, "parent");
            const spreeLeafTaxons = jsonApi.findRelationshipDocuments(spreeSuccessResponse, spreeTaxonParent, "children");
            leafTaxons = spreeLeafTaxons.map((child)=>{
                return {
                    id: child.id,
                    name: child.attributes.name,
                    permalink: child.attributes.permalink
                };
            });
        } catch (error2) {
            leafTaxons = null;
        }
    }
    return {
        id: spreeTaxon.id,
        name: spreeTaxon.attributes.name,
        permalink: spreeTaxon.attributes.permalink,
        description: spreeTaxon.attributes.description || "",
        children: children,
        image: taxonImage,
        metaTitle: spreeTaxon.attributes.meta_title,
        metaDescription: spreeTaxon.attributes.meta_description,
        rootTaxonomy: spreeTaxonomy == null ? void 0 : spreeTaxonomy.attributes.name,
        isLeaf: isLeaf,
        leafTaxons: leafTaxons
    };
};
export default normalizeTaxon;
